// extracted by mini-css-extract-plugin
export var body = "BoxNavigation-module--body--Bvww0";
export var component = "BoxNavigation-module--component--Za3E1";
export var header = "BoxNavigation-module--header--lLeDc";
export var item = "BoxNavigation-module--item--At8FD";
export var link = "BoxNavigation-module--link--iBi5c";
export var list = "BoxNavigation-module--list--PDYSR";
export var preamble = "BoxNavigation-module--preamble--G4Y2J";
export var title = "BoxNavigation-module--title--zbvQs";